import { render } from "./reviewPopup.vue?vue&type=template&id=7c0f963d&scoped=true"
import script from "./reviewPopup.vue?vue&type=script&lang=js"
export * from "./reviewPopup.vue?vue&type=script&lang=js"

import "./reviewPopup.vue?vue&type=style&index=0&id=7c0f963d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0f963d"]])

export default __exports__